const FrameworkAuthCheck = (resource, actionType, permissions) => {

    var key = actionType != 'menuAuth' ? actionType + 'AUTH' : actionType;
    // console.log('Checking permission ' + key + ' for ' + key)
    var passedAuth;

    if (!permissions) {
        console.log('Permissions not loaded');
        return false;
    }
    if (!resource[key]) {
        // console.log('No auth required');
        passedAuth = true;
    } else {
        var required = resource[key];
        var has = permissions[required];
        // console.log({permissions});
        // console.log('auth required: ' + required);
        // console.log('auth check passed: ' + has);
        passedAuth = has;
    }

    if (!passedAuth)
        return false;

    var passedCustomAuth = checkCustomAuth(resource, actionType, permissions);

    return passedCustomAuth;

}


const checkCustomAuth = (resource, actionType, permissions) => {
    var key = actionType + 'CUSTOMAUTH';
    var check = resource[key];
    if (!check)
        return true;
    console.log("Checking custom resource level auth: " + key);
    var customAuth = check(resource, permissions);
    console.log("Custom auth result: " + customAuth);
    return customAuth;

}



export default FrameworkAuthCheck;